import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { Pressable, ScrollView, View } from 'react-native'
import { ThemedValues } from 'styles/themed'
import Text from "theme/Text";
import HelperString from 'utils/helper-string'
import { TopNavigationTabBarStyles } from 'styles/components/atoms/TopNavigationTabBar';


const TopNavigationTabBar = ({ items = [], noMargin, onPress }) => {
	const [ selected, setSelected ] = useState( null )
	
	const onTabPress = ( data, index ) => {
		setSelected( data );
		
		if( _.isFunction( onPress ) ) {
			onPress( data, _.find( items, { key: data } ) );
		}
	}
	
	let selectedItem = _.find( items, { key: selected } )
	if( _.isUndefined( selectedItem ) ) {
		selectedItem = _.first( items )
	}
	
	const scrollViewStyle = [
		TopNavigationTabBarStyles.buttonGroup,
		{ marginVertical: noMargin ? 0 : ThemedValues.marginVertical }
	]
	
	const buttonActiveStyle = [
		TopNavigationTabBarStyles.button,
		TopNavigationTabBarStyles.buttonActive
	]
	
	const buttonActiveTextStyle = [
		TopNavigationTabBarStyles.buttonText,
		TopNavigationTabBarStyles.buttonTextActive
	]
	
	useEffect( () => {
		if( typeof selectedItem !== 'undefined' ) {
			onTabPress( selectedItem?.key )
		}
	}, [] )
	
	return (
		<View>
			<ScrollView
				style={ scrollViewStyle }
				horizontal={ true }
				showsHorizontalScrollIndicator={false}>
				
				<>
					{ _.map( items, ( button, index ) => {
						const { key, text, testID } = button;
						const isActive = (key === _.get( selectedItem, 'key' ) );
						
						return (
							<Pressable
								key={ HelperString.hash( 'top-navigation-tab-bar-item', key ) }
								onPress={ onTabPress.bind( this, key, index  ) }
								accessibilityRole="tab"
								accessibilityLabel={ text }
								accessibilityState={{ selected: isActive }}
								testID={ testID }>
								
								<View
									key={ HelperString.hash( 'button', button ) }
									style={ isActive ? buttonActiveStyle : TopNavigationTabBarStyles.button }>
									
									<View
										style={ TopNavigationTabBarStyles.buttonContent }>
										
										<Text
											style={ isActive ? buttonActiveTextStyle :TopNavigationTabBarStyles.buttonText }>
											
											{ text }
										</Text>
									</View>
								</View>
							</Pressable>
						)
					})}
				</>
			</ScrollView>
		</View>
	)
}

export default TopNavigationTabBar


